<app-lfsa-card-v2 *ngIf="mostrarFormulario === FROM_GRID" [innTemplateButton]="innTemplateButton"
    [innTemplate]="enviarTemplate" [titulo]="'Usuarios'" [modulo]="'Admin Seguridad'" [tituloCard]="'Listar Usuarios'">
</app-lfsa-card-v2>

<ng-template #innTemplateButton>
    <div class="col-md-6">
        <div class="pagetitle">
            <div class="btn-group-justified btn-group" style="float: right;">
                <a class="btn btn-outline-success" (click)="nuevo()">
                    <span class="fa fa-plus"></span>
                    {{DAT_BTNS.agregarUsuario}}</a>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #enviarTemplate>
    <section class="section">
        <div class="row">
            <div class="col-md-12 ">
                <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
                <ag-grid-angular class="{{diccionarioModulo.agGrid.class}}" [floatingFilter]="true" #agGrid
                    [ngStyle]="diccionarioModulo.agGrid.style" id="{{diccionarioModulo.agGrid.id}}"
                    [paginationPageSize]="$any(diccionarioModulo.agGrid).paginacion" [pagination]="true"
                    [frameworkComponents]="frameworkComponents " [columnDefs]="columnDefs "
                    [overlayLoadingTemplate]="overlayLoadingTemplate"
                    [rowSelection]="rowSelection" [rowData]="rowData " (gridReady)="onGridReady($event)">
                </ag-grid-angular>
            </div>
        </div>
    </section>
</ng-template>

<app-lfsa-card-v2 *ngIf="mostrarFormulario === FORM_ROLES" [innTemplateButton]="innTemplateButtonRol"
    [innTemplate]="enviarTemplateRol" [titulo]="'Usuarios'" [modulo]="'Admin Seguridad'" [tituloCard]="'Agregar Roles'">
</app-lfsa-card-v2>

<ng-template #innTemplateButtonRol>
    <div class="col-md-6">
        <div class="pagetitle">
            <div class="btn-group-justified btn-group" style="float: right;">
                <!-- <h4 class="card-title text-right">Usuario: {{userRol}}</h4> -->
                <button class={{DAT_BTNCSS.danger}} (click)="regresar()">{{DAT_BTNS.regresar}}</button>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #enviarTemplateRol>
    <div class="row">
        <div class="col-sm-6">
            <div class="card">
                <div class="card-header">
                    <strong>Rol por usuario</strong>
                </div>
                <div class="card-body">
                    <form [formGroup]="formularioRol" novalidate class="form-group">
                        <div class="row">
                            <div class="form-group col-12 col-md-12">
                                <app-lfsa-combo-box [opcion]="'descripcion'" [idOpcion]="'id'" [comboBox]="cmbListRol"
                                    formControlName="rolId" [control]="formularioRol.get('rolId')" [id]="'idRol'">
                                </app-lfsa-combo-box>
                            </div>
                            <div class="form-group col-12 col-md-6" hidden="false">
                                <app-lfsa-input [placeholder]="'Id'" [label]="'Id'" [id]="'id'"
                                    formControlName="usuarioId" [control]="formularioRol.get('usuarioId')">
                                </app-lfsa-input>
                            </div>
                        </div>
                        <button [disabled]="formularioRol.invalid" class="{{DAT_BTNCSS.success}}"
                            (click)="guardarRol()"><i
                                class="fa fa-plus-square">&nbsp;</i>{{DAT_BTNS.agregarRol}}</button>
                    </form>
                    <ag-grid-angular [floatingFilter]="true" #agGrid style="width: 100%; height: 350px; "
                        class="ag-theme-alpine mt-3" [frameworkComponents]="frameworkComponents "
                        [columnDefs]="columnDefsRol" [rowSelection]="rowSelection" [isRowSelectable]="isRowSelectable"
                        [rowData]="rowDataRol" (gridReady)="onGridReadyRol($event)">
                    </ag-grid-angular>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="card">
                <div class="card-header">
                    <strong>Autorización</strong>
                </div>
                <div class="card-body">
                    <form [formGroup]="formularioAuthority" novalidate class="form-group">
                        <div class="row">
                            <div class="form-group col-12 col-md-12">
                                <app-lfsa-combo-box [opcion]="'name'" [idOpcion]="'name'" [comboBox]="authority"
                                    formControlName="authorityName" [control]="formularioAuthority.get('authorityName')"
                                    [id]="'authorityName'">
                                </app-lfsa-combo-box>
                            </div>
                            <div class="form-group col-12 col-md-6" hidden="false">
                                <app-lfsa-input [placeholder]="'Id'" [label]="'Id'" [id]="'id'" formControlName="userId"
                                    [control]="formularioAuthority.get('userId')">
                                </app-lfsa-input>
                            </div>
                        </div>
                        <button [disabled]="formularioAuthority.invalid" class={{DAT_BTNCSS.success}}
                            (click)="guardarAutorizacion()"><i
                                class="fa fa-plus-square">&nbsp;</i>{{DAT_BTNS.agregarAutorizacion}}</button>
                    </form>
                    <ag-grid-angular #agGrid style="width: 100%; height: 350px; " class="ag-theme-alpine mt-3"
                        [frameworkComponents]="frameworkComponents " [columnDefs]="columnDefsAuthority"
                        [rowSelection]="rowSelection" [rowData]="rowDataAutorizacion"
                        [floatingFilter]="true"
                        (gridReady)="onGridReadyAutorizacion($event)">
                    </ag-grid-angular>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<app-lfsa-card-v2 *ngIf="mostrarFormulario === FORM_EDITAR" [innTemplateButton]="innTemplateButtonEditar"
    [innTemplate]="enviarTemplateEditar" [titulo]="'Usuarios'" [modulo]="'Admin Seguridad'"
    [tituloCard]="'Editar Usuario'">
</app-lfsa-card-v2>

<ng-template #innTemplateButtonEditar>
</ng-template>
<ng-template #enviarTemplateEditar>
    <div class="row animated fadeInRight">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <strong>Buscar Usuario</strong>
                </div>
                <div class="card-body">
                    <form [formGroup]="formularioBuscar" novalidate class="form-group">
                        <div class="row">
                            <div class="col-md-6">
                                <app-lfsa-input [placeholder]="'Usuario'" [label]="'Nombre Usuario'" [id]="'nombres'"
                                    formControlName="nombreUser" [control]="formularioBuscar.get('nombreUser')">
                                </app-lfsa-input>
                            </div>
                            <div class="col-md-3">
                                <label>&nbsp;</label>
                                <button [disabled]="formularioBuscar.invalid"
                                    class="{{diccionarioModulo.button.buttonsCss.success}}" (click)="buscarUsuario()">
                                    <i class="fa fa-search"></i>
                                    {{diccionarioModulo.button.buttonsNombre.buscar}}</button>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
    <br>
    <div class="row animated fadeInRight">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <strong>Usuarios</strong>
                </div>
                <div class="card-body">
                    <form [formGroup]="formulario" novalidate class="form-group">

                        <div class="row">
                            <div class="form-group col-sm-12 col-md-6 col-lg-4" *ngIf="hide">
                                <app-lfsa-input [placeholder]="'Id'" [label]="'Id'" [id]="'id'" formControlName="id"
                                    [control]="formulario.get('id')"></app-lfsa-input>
                            </div>
                            <div class="form-group col-sm-12 col-md-6 col-lg-4">
                                <app-lfsa-input [placeholder]="'Nombres'" [label]="'Nombres'" [id]="'nombres'"
                                    formControlName="nombre" [control]="formulario.get('nombre')"></app-lfsa-input>
                            </div>
                            <div class="form-group col-sm-12 col-md-6 col-lg-4">
                                <app-lfsa-input [placeholder]="'Apellidos'" [label]="'Apellidos'" [id]="'apellidos'"
                                    formControlName="apellido" [control]="formulario.get('apellido')"></app-lfsa-input>
                            </div>
                            <div class="form-group col-sm-6 col-md-6 col-lg-4">
                                <app-lfsa-input [type]="'email'" [placeholder]="'Correo'" [label]="'Correo'"
                                    [id]="'email'" formControlName="email" [control]="formulario.get('email')">
                                </app-lfsa-input>
                            </div>
                            <div class="form-group col-sm-6 col-md-6 col-lg-3">
                                <app-lfsa-input [placeholder]="'Login'" [label]="'Login'" [id]="'login'"
                                    formControlName="login" [control]="formulario.get('login')"></app-lfsa-input>
                            </div>
                            <div class="form-group col-sm-6 col-md-6 col-lg-3">
                                <app-lfsa-input [isReadOnly]='habiliarLogin2' [placeholder]="'Usera DA'"
                                    [label]="'Usera DA'" [id]="'login'" formControlName="login2"
                                    [control]="formulario.get('login2')"></app-lfsa-input>
                            </div>
                            <div class="form-group col-sm-6 col-md-3 col-lg-3">
                                <div class="row">
                                    <label>AD</label>
                                </div>
                                <div class="btn-group-justified btn-group">
                                    <label class="btn btn-light valid">
                                        <input type="radio" [id]="'radActivo'" [checked]='ldapBoll == true'
                                            formControlName="ldap" [value]="1" (click)="ldapPassword('1')" />
                                        <span> Activo</span>
                                    </label>
                                    <label class="btn btn-light">
                                        <input type="radio" [checked]='ldapBoll == false' formControlName="ldap"
                                            [value]="2" (click)="ldapPassword('2')" />
                                        <span> Inactivo</span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-sm-6 col-md-3 col-lg-3">
                                <app-lfsa-combo-box [opcion]="'valor'" [idOpcion]="'id'" [comboBox]="status"
                                    formControlName="status" [control]="formulario.get('status')" [label]="'Estado'"
                                    [id]="'status'"></app-lfsa-combo-box>
                            </div>


                        </div>
                        <app-lfsa-botones-formulario [formularioValido]="formulario.invalid"
                            (devolverAccion)="acciones ( $event )" [textBoton]="textBoton">
                        </app-lfsa-botones-formulario>
                    </form>
                </div>
            </div>
        </div>
    </div>
</ng-template>
